<ion-content>
  <div class="px-4 py-2 padding-bottom-configuration">
    <app-header-configuration
      [title]="'P0003605.installation.bidon.titre' | translate"
      [description]="'P0003605.installation.bidon.description' | translate"
    >
    </app-header-configuration>

    <app-switch-configuration
      [nameCustom]="'P0003605.installation.installé' | translate"
      [value]="actionStack!.getValue('icIDetecteurFinBidonInstalle') !== 0"
      (onPress)="
        this.actionStack!.editValue(
          P00039DataRxTxIndex.InjectionChlore_Installation,
          'icIDetecteurFinBidonInstalle',
          $event ? 1 : 0,
          null
        )
      "
    >
    </app-switch-configuration>

    @if (this.actionStack!.getValue('icIDetecteurFinBidonInstalle') === 1) {
      <app-label-configuration
        [titleListe]="'P0003605.installation.contact' | translate"
        [value]="actionStack!.getValue('icISensContactFinBidon')"
        [liste]="P0003605SensContactEnum"
        (onPress)="goDetectionModal($event)"
      >
      </app-label-configuration>
    }
  </div>
</ion-content>

<div class="position-absolute start-0 end-0 bottom-0 bg-white px-4 py-2">
  <div class="row">
    <div class="col-6 text-start">
      <ion-button
        color="medium"
        expand="block"
        fill="outline"
        class="mb-3"
        (click)="this.prev()"
      >
        {{ 'generic.retour' | translate }}
      </ion-button>
    </div>
    <div class="col-6 text-end">
      <ion-button color="primary" expand="block" (click)="onSubmit()">
        {{ 'generic.next' | translate }}
      </ion-button>
    </div>
  </div>
</div>
